import React from "react";
import "./UserInfo.css";
import TextLabel from "../../Controls/TextLabel.mjs";
import {Button, ButtonGroup, Col, Row} from "reactstrap";
import appLib from "../../libs/appLib.mjs";
import VSwitch from "../../Controls/VSwitch.mjs";
import HermesBayLogo from "../../media/images/HermesBayLogo.mjs";
import AppFullLogo from "../../media/images/AppFullLogo.mjs";

const G = window.glob;

const UserInfo = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			appinfo: G.getStatus('AppInfo'),
			player: G.getStatus('Player'),
			game: G.getStatus('GameStatus'),
			lang: G.getLanguage(),
			soundenabled: 'unk'
		};
		this.uid = G.generateUid('UserInfo');
		this.fetchSoundStatus = this.fetchSoundStatus.bind(this);
		this.renderAppInfo = this.renderAppInfo.bind(this);
	}
	componentDidMount() {
		G.register('Player', (p)=>{
			this.setState({ player: p });
		}, this.uid);
		G.register('GameStatus', (i)=>{
			this.setState({ game: i });
			this.fetchSoundStatus();
		}, this.uid);
		G.register('Prefs', (p)=>{
			if ( p?.language && p?.language !== this.state.lang ) this.setState({ lang: p.language });
		}, this.uid);
		G.register('PlayerStatus', () => { this.fetchSoundStatus(); }, this.uid);
		this.fetchSoundStatus();
	}
	async fetchSoundStatus() {
		const v = this.state.game ? String( !! await appLib.isSoundEnabled() ) : 'unk';
		if ( v !== this.state.soundenabled ) this.setState({ soundenabled: v });
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	renderRoles(r) {
		if ( ! r ) return <TextLabel value={"None"}/>;
		if ( r.length === 1 ) return r[0].name;
		return (
			<ul>
				{
					r.sort(
						(a,b)=>{
							return ( a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1 );
						}
					).map(
						x => {
							return <li key={x.id}>{x.name}</li>;
						}
					)
				}
			</ul>
		);
	}
	renderAppInfo() {
		const params = {customer: this.state.appinfo.desc};
		const out = [];
		for( let i=1; i < 100; i++ ){
			const lk = 'AppInfoLine'+i;
			const l = G.label(lk,params);
			if ( l.startsWith('AppInfoLine')) break;
			out.push( <p key={i}>{ l }</p> );
		}
		return out;
	}
	render() {
		if ( ! this.state.player ) return <p/>;
		const p = this.state.player;
		return (
			<div
				className={"UserInfo"}
				id={this.uid}
			>
				<h1>
					<TextLabel value={"UserInfo"}/>
				</h1>
				<div className={"UserIcon"}>
					{p.icon}
				</div>
				<div className={"info"}>
					{this.state.game ?
						<Row>
							<Col sm={3}>
								<TextLabel value={"Game"}/>
							</Col>
							<Col sm={9}>
								{this.state.game.name}
							</Col>
						</Row>
						: ''
					}
					<Row>
						<Col sm={3}>
							<TextLabel value={"Username"}/>
						</Col>
						<Col sm={9}>
							{p.name}
						</Col>
					</Row>
					<Row>
						<Col sm={3}>
							<TextLabel value={(p.roles && p.roles.length === 1) ? "Actual role" : "Actual roles"}/>
						</Col>
						<Col sm={9}>
							{this.renderRoles(p.roles)}
						</Col>
					</Row>
					{this.state.game ?
						<Row>
							<Col sm={3}>
								<TextLabel value={"Notification sounds"}/>
							</Col>
							<Col sm={9} key={this.state.soundenabled + ' ' + this.state.lang}>
								<VSwitch
									current={this.state.soundenabled}
									items={[
										{value: "true", label: G.label('Ons')},
										{value: "false", label: G.label('Offs')},
									]}
									onChange={s => {
										if (s && s?.value) appLib.setPlayerStatus(s.value === 'true', 'notificationsound');
									}}
								/>
							</Col>
						</Row>
						: ''
					}
				</div>
				<div className={"mt-4 mb-4"}>
					<ButtonGroup vertical={false}>
						{this.state.game ?
							<Button
								color={"warning"}
								className={"btn-icon"}
								onClick={() => {
									appLib.closeGame();
								}}
							>
								<i><TextLabel value={"back"} lang={"icon"}/></i>
								<b><TextLabel value={"ExitGame"}/></b>
							</Button>
							: ''
						}
						<Button
							color={"danger"}
							className={"btn-icon"}
							onClick={() => {
								appLib.logout()
							}}
						>
							<i><TextLabel value={"cancel"} lang={"icon"}/></i>
							<b><TextLabel value={"Logout"}/></b>
						</Button>
					</ButtonGroup>
				</div>
				<div className={"logos"}>
					<div>
						<AppFullLogo/>
					</div>
					<div>
						<HermesBayLogo/>
					</div>
				</div>
				<div className={"copy"}>
					{ this.renderAppInfo() }
				</div>
			</div>
		);
	}
}

export default UserInfo;